import script from "./music.vue?vue&type=script&setup=true&lang=js"
export * from "./music.vue?vue&type=script&setup=true&lang=js"

import "./music.vue?vue&type=style&index=0&id=6757763e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6757763e"]])

export default __exports__